import TopicGhostChip from '@src/basic-components/TopicChip/TopicGhostChip';
import { ensureTokenUrl } from '@src/model/config/helpers';
import React, { type FC, memo, useCallback } from 'react';
import { useHistory } from 'react-router-dom';

interface TopicsBarItemProps {
    className?: string;
    tokenName: string;
    isActive?: boolean;
    name: string;
    id: string;
}

const TopicsBarItem: FC<TopicsBarItemProps> = props => {
    const { id, tokenName, name, isActive } = props;

    const history = useHistory();

    const onClick = useCallback(() => {
        if (isActive) return history.push(`/${ensureTokenUrl(tokenName)}`);
        return history.push(`/${ensureTokenUrl(tokenName)}/${id}`);
    }, [isActive, id, tokenName]);

    return <TopicGhostChip isActive={isActive} id={id} name={name} onClick={onClick} />;
};

export default memo(TopicsBarItem);
